import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ParkingsService {
  // convertPayload(form: FormGroup, coordinates: ICoordinatesFromCrudMap): IParkingModel {
  //   const { type, zoneUuid, categoryUuid, ...rest } = form.getRawValue();
  //   const coords = coordinates;
  //
  //   return {
  //     ...rest,
  //     center: coords?.center,
  //     location: this.createLocationPayload(type, coords?.coordinates as ICoordinatesModel[]),
  //     ...this.createUuidPayload(zoneUuid, categoryUuid),
  //   };
  // }
  //
  // private createLocationPayload(
  //   type: IParkingLocationEnum,
  //   coordinates: ICoordinatesModel[],
  // ): IParkingLocationModel {
  //   const locationMap = {
  //     [IParkingLocationEnum.Polygon]: () => ({ type: type, polygon: { coordinates } }),
  //     [IParkingLocationEnum.Line]: () => ({ type: type, line: { coordinates } }),
  //     [IParkingLocationEnum.Point]: () => ({
  //       type: type,
  //       point: { longitude: coordinates[0].longitude, lattitude: coordinates[0].lattitude },
  //     }),
  //   };
  //
  //   return (locationMap[type] ?? locationMap[IParkingLocationEnum.Point])();
  // }
  //
  // private createUuidPayload(zoneUuid: string, categoryUuid: string): Partial<IParkingModel> {
  //   return {
  //     zoneUuid: { value: zoneUuid },
  //     categoryUuid: { value: categoryUuid },
  //   };
  // }
}
